import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "delivery-item__notified-quantity" };
import { computed } from 'vue';
import NumberInput from "@astina/paloma-common-ui/src/components/NumberInput.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoDeliveryItem',
    props: {
        item: {}
    },
    emits: ['updateReceivedQuantity'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const notifiedQuantity = computed(() => props.item.receivedQuantity ?? props.item.notifiedQuantity ?? props.item.orderedQuantity);
        function onQuantityUpdate(qty) {
            emit('updateReceivedQuantity', qty);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", null, _toDisplayString(__props.item.position), 1),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("td", null, _toDisplayString(__props.item.description), 1),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("td", null, _toDisplayString(__props.item.article?.internalArticleNumber ?? '–'), 1),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("td", null, _toDisplayString(__props.item.orderedQuantity === undefined ? '–' : __props.item.orderedQuantity) + " " + _toDisplayString(__props.item.article ? _ctx.$t('VensoUnit.' + __props.item.article.orderUnit) : ''), 1),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("td", null, [
                    (__props.item.notifiedQuantity != null)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(__props.item.notifiedQuantity) + " " + _toDisplayString(__props.item.article ? _ctx.$t('VensoUnit.' + __props.item.article.orderUnit) : ''), 1)
                        ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("\n                n.a.\n            ")
                        ], 64))
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(NumberInput, {
                            value: notifiedQuantity.value,
                            onChange: onQuantityUpdate,
                            min: 0
                        }, null, 8, ["value"])
                    ])
                ])
            ]));
        };
    }
});
